import React from 'react';
import './LeftNav.css';
import unicefIconOne from './../../../../assets/png/UNICEF One.png';

interface NavBarProps {
  navItemsModal: string[];
  activeIndex: number;
  onNavClick: (index: number) => void;
  completedIndices: boolean[];
}

const LeftNavBar: React.FC<NavBarProps> = ({
  navItemsModal,
  activeIndex,
  onNavClick,
  completedIndices,
}) => {
  return (
    <div className={`navbar-container-page`}>
      <ol>
        {navItemsModal.map((item, index) => (
          <li
            key={index}
            className={`nav-item ${activeIndex === index ? 'active' : ''} ${completedIndices[index] ? 'completed' : ''}`}
            onClick={() => onNavClick(index)}
          >
            {item}
          </li>
        ))}
      </ol>
    </div>
  );
};

export default LeftNavBar;
